import { type Module } from "vuex";
import type { ActivityLogResponse, DefaultApi } from "@/api";
import { ActivityLog } from "@/models/activity_log";
import { ActivityLogs } from "@/models/activity_logs";
import type { State as RootState } from "@/stores";
export interface State {
  activityLogs?: ActivityLogs;
}
export const module: Module<State, RootState> = {
  namespaced: true,
  actions: {
    async getActivityLogs({ commit }) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.getActivityLogs();
      const logs = new ActivityLogs(
        response.data.map(
          (log: Partial<ActivityLogResponse>) => new ActivityLog(log),
        ),
      );
      commit("setActivityLogs", logs);
      return logs;
    },
  },
  mutations: {
    setActivityLogs(state, logs: ActivityLogs) {
      state.activityLogs = logs;
    },
  },
};
